// src/questionnaire/icon-mapping.js
import {
    Users,
    UserCheck,
    Handshake,
    Wallet,
    Clock,
    Shield,
    FileText,
    Scale,
    Lightbulb,
    Search,
    Rocket,
    FileSignature,
    Cpu,
    Megaphone,
    ScrollText,
    Briefcase,
    Star,
    Crosshair,
    DollarSign,
    Banknote,
    AlertTriangle,
    Package,
    Target,
    UserX,
    Puzzle,
    Settings,
    Globe,
    Factory,
    Truck,
    Tag,
    PieChart,
    Eye,
    MapPin,
    TrendingUp,
    Gavel,
    Landmark,
    Lock,
    Trophy,
    Mic,
    Network
} from "lucide-react";

export const getFactorIcon = (factorName) => {
    const iconMap = {
        // Reserved Pool Questions
        "Employee Stock Pool": <Users size={20} />,
        "Independent Directors": <UserCheck size={20} />,
        "Third Party Advisors": <Handshake size={20} />,
        "Potential Investors": <Wallet size={20} />,

        // Core Factors
        "Opportunity Costs": <Clock size={20} />,
        "Personal Risk": <Shield size={20} />,
        "IP/Patent": <FileText size={20} />,
        "Liability Assumption": <Scale size={20} />,

        // Pre-Formation
        "Idea": <Lightbulb size={20} />,
        "Research/Market Data": <Search size={20} />,
        "MVP": <Rocket size={20} />,
        "Signed Contracts": <FileSignature size={20} />,
        "Prototype": <Cpu size={20} />,
        "Social Presence": <Megaphone size={20} />,
        "LOI/Pre-approval": <ScrollText size={20} />,
        "Business Plan/Modelling": <Briefcase size={20} />,
        "Brand Establishment": <Tag size={20} />,
        "Investment approvals": <Wallet size={20} />,

        // Role & Responsibility
        "Rare Expertise": <Star size={20} />,
        "Key Milestones Impact": <Target size={20} />,
        "Strategic Role": <Crosshair size={20} />,
        "Revenue/Partnership Impact": <DollarSign size={20} />,
        "Regulatory/Compliance Onus": <Scale size={20} />,
        "Pre-Revenue Salary Need": <Banknote size={20} />,
        "Business Continuity Risk": <AlertTriangle size={20} />,
        "Service Impact": <Package size={20} />,
        "Key Component Risk": <Puzzle size={20} />,
        "Customer Acquisition Difficulty": <UserX size={20} />,
        "Time to Market Delay": <Clock size={20} />,
        "Founder Reliant Product/Service": <Settings size={20} />,

        // Experience & Networks
        "Influencer Status": <Megaphone size={20} />,
        "Speaker/Writer": <Mic size={20} />,
        "Research Grants": <Wallet size={20} />,
        "Trade Secrets": <Lock size={20} />,
        "Successful Exits": <Trophy size={20} />,
        "Social Capital": <Network size={20} />,
        "Product Knowledge": <Package size={20} />,
        "Industry Knowledge": <Globe size={20} />,
        "Supplier Knowledge": <Factory size={20} />,
        "Manufacturing Knowledge": <Settings size={20} />,
        "Distribution Knowledge": <Truck size={20} />,
        "Operations Knowledge": <Settings size={20} />,
        "Marketing Knowledge": <Tag size={20} />,
        "Financial Knowledge": <PieChart size={20} />,
        "Competitor Knowledge": <Eye size={20} />,
        "Local Knowledge": <MapPin size={20} />,
        "Global Expansion": <Globe size={20} />,
        "Scaling Knowledge": <TrendingUp size={20} />,
        "Regulatory Knowledge": <Gavel size={20} />,
        "Lobbying Knowledge": <Landmark size={20} />,
        "Legal Knowledge": <Scale size={20} />,
        "Fundraising Network": <Network size={20} />,
        "Regulatory Network": <Landmark size={20} />,
        "Supplier Network": <Factory size={20} />,
        "Manufacturing Network": <Settings size={20} />,
        "Recruiting Network": <Users size={20} />,
        "Distribution Network": <Truck size={20} />,
        "Client Network": <Users size={20} />
    };

    return iconMap[factorName] || <Briefcase size={20} />;
};
